import { CurecallBanner, CurecallCardService } from '@honestica/curecall-ui'
import { TFollowup } from 'src/types/followup'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useTranslation } from 'react-i18next'

export type Props = {
  onClickOnCard: (followup: TFollowup) => void
  selectedFollowup?: TFollowup | null
  addFollowup?: VoidFunction
  addFollowupLabel?: string
}

const FollowupCardList = ({ selectedFollowup, onClickOnCard, addFollowup, addFollowupLabel }: Props) => {
  const { followups } = useCurrentProject()
  const { t } = useTranslation()

  if (followups?.length === 0)
    return (
      <CurecallBanner>{t('pages.patient-page.add-followup.no-followup-contact-curecall')}</CurecallBanner>
    )

  return (
    <div className="c-flex c-gap-4 xl:c-gap-6 c-min-h-0 c-w-full c-flex-wrap">
      {addFollowup && (
        <CurecallCardService onClick={addFollowup} withoutBackground={true}>
          {addFollowupLabel}
        </CurecallCardService>
      )}
      {followups.map((followup) => (
        <CurecallCardService
          key={followup.name}
          isCardActive={selectedFollowup?.id === followup.id}
          onClick={() => onClickOnCard(followup)}
          gradientName={followup.configUI?.followupUI?.card?.gradientName}
        >
          {followup.name}
        </CurecallCardService>
      ))}
    </div>
  )
}

export default FollowupCardList
